import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Add CSRF token to axios requests
const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
if (csrfToken) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
}

// Update axios CSRF token when meta tag changes (after Inertia navigation)
const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'content') {
            window.axios.defaults.headers.common['X-CSRF-TOKEN'] = mutation.target.getAttribute('content');
        }
    });
});

const metaTag = document.querySelector('meta[name="csrf-token"]');
if (metaTag) {
    observer.observe(metaTag, { attributes: true });
}

/*
 * A page left open longer than the session holds a token the server no longer
 * knows, and every request it sends is refused with 419: an applicant coming
 * back to a half-filled form could not even reload their answers. The refused
 * response starts a new session, so the page is fetched again for that
 * session's token, and the request is sent once more with it.
 */
const fetchOriginal = window.fetch.bind(window);

async function csrfTokenRefresh() {
    const response = await fetchOriginal(window.location.href, { credentials: 'same-origin', headers: { Accept: 'text/html' } });
    const token = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('meta[name="csrf-token"]')?.getAttribute('content');

    if (token) {
        document.querySelector('meta[name="csrf-token"]')?.setAttribute('content', token);
    }

    return token;
}

window.fetch = async (input, init = {}) => {
    const response = await fetchOriginal(input, init);
    const headers = new Headers(init.headers);

    if (response.status !== 419 || !headers.has('X-CSRF-TOKEN')) {
        return response;
    }

    const token = await csrfTokenRefresh();

    if (!token) {
        return response;
    }

    headers.set('X-CSRF-TOKEN', token);

    return fetchOriginal(input, { ...init, headers });
};

window.axios.interceptors.response.use(undefined, async (error) => {
    const config = error.config;

    if (error.response?.status !== 419 || !config || config.csrfRetried) {
        throw error;
    }

    const token = await csrfTokenRefresh();

    if (!token) {
        throw error;
    }

    config.csrfRetried = true;
    config.headers['X-CSRF-TOKEN'] = token;

    return window.axios(config);
});
